import api from "./api";
import { URL_APP_BASE_PATH } from "../configs/constants";

export class AnnouncementService {
  getByOrganization = async () => {
    const url = `${URL_APP_BASE_PATH}/announcements/organization`;
    try {
      const { data } = await api.get(url);
      return data;
    } catch (err) {
      return null;
    }
  };
}

const announcementService = new AnnouncementService();
export default announcementService;
